// project imports
// action - state management
import * as actionTypes from "../../actions/actionTypes";
import { years } from "store/utils/years";
import {
  churnRateMonths,
  costPerInstallMonths,
  mediaBuyingMonths,
  registrationMonths,
  subscriptionMonths,
} from "./staticYearsData";

// This is to filter based on company types
import { SaaSCoType, GeneralCoType } from "constants/companyTypes";

// subscriber acquisition assumption' keys
export const MEDIA_BUYING_KEY = "mediaBuying";
export const COST_PER_INSTALL_KEY = "costPerInstall";
export const REGISTRATION_KEY = "registration";
export const SUBSCRIPTION_KEY = "subscription";
export const ANNUAL_CHURN_RATE_KEY = "annualChurnRate";
export const MONTHLY_CHURN_RATE_KEY = "monthlyChurnRate";

export const initialState = {
  [MEDIA_BUYING_KEY]: {
    unit: "USD",
    unitSymbol: "$",
    initialPeriod: 0,
    initialPeriodMonth: 0,
    months: mediaBuyingMonths,
    companyTypes: [SaaSCoType, GeneralCoType],
    years: {
      [years.YEAR_1_KEY]: 300000,
      [years.YEAR_2_KEY]: 300000,
      [years.YEAR_3_KEY]: 300000,
      [years.YEAR_4_KEY]: 300000,
      [years.YEAR_5_KEY]: 300000,
    },
  },
  [COST_PER_INSTALL_KEY]: {
    unit: "USD",
    unitSymbol: "$",
    initialPeriod: 0,
    initialPeriodMonth: 0,
    months: costPerInstallMonths,
    companyTypes: [SaaSCoType, GeneralCoType],
    years: {
      [years.YEAR_1_KEY]: 2.5,
      [years.YEAR_2_KEY]: 2,
      [years.YEAR_3_KEY]: 1.5,
      [years.YEAR_4_KEY]: 1.25,
      [years.YEAR_5_KEY]: 1,
    },
  },
  [REGISTRATION_KEY]: {
    unit: "PERCENTAGE",
    unitSymbol: "%",
    initialPeriod: 0,
    initialPeriodMonth: 0,
    months: registrationMonths,
    companyTypes: [SaaSCoType, GeneralCoType],
    years: {
      [years.YEAR_1_KEY]: 50,
      [years.YEAR_2_KEY]: 50,
      [years.YEAR_3_KEY]: 50,
      [years.YEAR_4_KEY]: 50,
      [years.YEAR_5_KEY]: 50,
    },
  },
  [SUBSCRIPTION_KEY]: {
    unit: "PERCENTAGE",
    unitSymbol: "%",
    initialPeriod: 0,
    initialPeriodMonth: 0,
    months: subscriptionMonths,
    companyTypes: [SaaSCoType, GeneralCoType],
    years: {
      [years.YEAR_1_KEY]: 3.5,
      [years.YEAR_2_KEY]: 3.5,
      [years.YEAR_3_KEY]: 3.5,
      [years.YEAR_4_KEY]: 3.5,
      [years.YEAR_5_KEY]: 3.5,
    },
  },
  [ANNUAL_CHURN_RATE_KEY]: {
    unit: "PERCENTAGE",
    unitSymbol: "%",
    initialPeriod: 0,
    initialPeriodMonth: 0,
    months: churnRateMonths,
    companyTypes: [SaaSCoType, GeneralCoType],
    years: {
      [years.YEAR_1_KEY]: 55,
      [years.YEAR_2_KEY]: 55,
      [years.YEAR_3_KEY]: 55,
      [years.YEAR_4_KEY]: 55,
      [years.YEAR_5_KEY]: 55,
    },
  },
  [MONTHLY_CHURN_RATE_KEY]: {
    unit: "PERCENTAGE",
    unitSymbol: "%",
    initialPeriod: 0,
    initialPeriodMonth: 0,
    months: churnRateMonths,
    companyTypes: [SaaSCoType, GeneralCoType],
    years: {
      [years.YEAR_1_KEY]: 45,
      [years.YEAR_2_KEY]: 45,
      [years.YEAR_3_KEY]: 45,
      [years.YEAR_4_KEY]: 45,
      [years.YEAR_5_KEY]: 45,
    },
  },
};

// ==============================|| SUBSCRIPTION ACQUISITION ASSUMPTIONS REDUCER ||============================== //

const subscriberAcquisitionAssumptionsReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case actionTypes.SET_SUBSCRIBER_ACQUISITION_ASSUMPTION_BY_YEAR:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          years: {
            ...state[action.key].years,
            [action.yearKey]: [action.amount],
          },
        },
      };
    case actionTypes.SET_SUBSCRIBER_ACQUISITION_ASSUMPTION_BY_MONTH:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: {
            ...state[action.key].months,
            [action.yearKey]: [action.amount],
          },
        },
      };
    case actionTypes.RESET_SUBSCRIBER_ACQUISITION_ASSUMPTION_REDUCER:
      return initialState;
    default:
      return state;
  }
};

export default subscriberAcquisitionAssumptionsReducer;
